import { SupportedMarketKey } from '@nxt-insurance/constants'

import { getCommonFlowConfig } from '@flows/configs/common'
import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import * as flowConfigUtils from '@flows/insurance/utils'

import schema from './schema'
import { getSteps } from './steps'

const getContentsConfig = ({
  clientHelpers,
  subFlow = SubFlow.ContentsNxt,
  market,
}: FlowConfigProps) => {
  const productKey = 'contents_v1_getsafe_de'
  const stepParams = {
    clientHelpers,
    productKey,
    helperFunctions: flowConfigUtils.generateGetFlowValueFunctions(productKey),
    subFlow,
    market,
  } satisfies StepConfigParams

  const common = getCommonFlowConfig({
    getMarket: () => SupportedMarketKey.De,
    apiService: clientHelpers.apiService,
  })

  const productSteps = getSteps(stepParams)

  const allSteps = {
    ...productSteps,
    emailAndName: {
      ...common.emailAndName,
      showOrderSummary: true,
      nextStep: 'gender',
    },
    gender: {
      ...common.gender,
      showOrderSummary: true,
      nextStep: 'payment',
    },
  }

  return getProductFlowConfiguration('contents_v1_getsafe_de', allSteps, {
    constants: {
      FIRST_STEP_NAME: 'contents_birthday',
      POST_QUOTE_STEP: 'contents_wg_insured',
      SCHEMA: schema,
    },
    getInitialValues: () => ({
      [productKey]: {
        productKey,
        configuration_parameters: {
          tariff_line: 'premium',
        },
      },
    }),
    progressBarSections: [
      {
        name: SubFlow.ContentsNxt,
        type: 'insurance' as const,
        number: 1,
        label: 'sharedFlows_contentsNxt:progressBar.insurance',
      },
      {
        name: SubFlow.Common,
        type: 'personalDetails' as const,
        number: 2,
        label: 'sharedFlows_contentsNxt:progressBar.personalDetails',
      },
      {
        name: SubFlow.PaymentAndConfirmation,
        type: 'paymentAndConfirmation' as const,
        number: 3,
        label: 'sharedFlows_contentsNxt:progressBar.paymentAndConfirmation',
      },
    ],
  })
}

export default getContentsConfig
